import React, { createRef } from "react";
import {
  Select,
  Checkbox,
  Row,
  Col,
  Button,
  Space,
  DatePicker,
  Dropdown,
  Modal,
  Image,
  Tooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import VehicleStore from "../store/VehicleStore";
import dayjs from "dayjs";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
import FleetDaySummaryReportStore from "../store/FleetDaySummaryReportStore";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import PythonMessageAlert from "./PythonMessageAlert";
import conf from "../config";

const { Option } = Select;
let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length > 24) {
      val.width = 250;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 150;
    } else if (val.title?.length > 8) {
      val.width = 125;
    } else {
      val.width = 110;
    }
    // console.log(val.title.length)
  });

  return arr;
};
class FleetDaySummaryReport extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.fleetDaySummaryReport = new FleetDaySummaryReportStore(this);
    this.vehicleStore = new VehicleStore();
    this.pythonMessageRef = createRef();

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      selectedVehicles: [],

      selectAllVehicles: false,
      companyId: "",
      modalVisible: false,
      column: "",
      filter: "",
      showMonthPopup: false,
      Notcompany: false,
      Notasset: false,
      fromDate: dayjs().format("YYYY-MM-DD"),
      toDate: dayjs().format("YYYY-MM-DD"),
      reportmessage: "",
      toDateNotSelected: false,
      fromDateNotSelected: false,
      selectedColumns: widthAdderFunc([
        {
          // title: "Asset Name",
          title: context.translate("_VEHICLE_NO_"),
          dataIndex: "vehicleNo",
          key: "vehicleNo",
          ellipsis: {
            showTitle: true,
          },
          // fixed: 'left',
        },
        {
          // title: "Vehicle Type",
          title: context.translate("_VEHICLE_TYPE_"),
          dataIndex: "vehicleTypeNew",
          width: "15%",
          key: "vehicleTypeNew",
        },
        {
          // title: "Base Location",
          title: context.translate("_BASE_LOCATION_"),
          dataIndex: "baseLocation",
          width: "15%",
          key: "baseLocation",
        },
        {
          // title: "From Date",
          title: context.translate("_FROM_DATE_"),
          dataIndex: "fromDate",
          width: "15%",
          key: "fromDate",
          render: (value) => {
            return dayjs(this.state.fromDate).format("YYYY-MM-DD 12:00:00A");
          },
        },
        {
          // title: "Asset Type",
          title: context.translate("_FLEET_START_TIME_"),
          dataIndex: "startTime",
          key: "startTime",
          ellipsis: {
            showTitle: true,
          },
          render: (value) => {
            if (value) {
              const formattedDateTime = dayjs(value).format(
                "DD-MM-YYYY hh:mm:ss A"
              );
              return <>{formattedDateTime}</>;
            } else {
              return <></>;
            }
          },
        },
        {
          // title: "Driver Name",
          title: context.translate("_START_LOCATION_"),
          dataIndex: "startLocation",
          key: "startLocation",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "To Date"
          title: context.translate("_TO_DATE_"),
          dataIndex: "toDate",
          width: "15%",
          key: "toDate",
          render: (value) => {
            return this.state.toDate;
          },
        },
        {
          // title: "Date",
          title: context.translate("_FLEET_STOP_TIME_"),
          dataIndex: "stopTime",
          key: "stopTime",
          ellipsis: {
            showTitle: true,
          },
          render: (value) => {
            if (value) {
              const formattedDateTime = dayjs(value).format(
                "DD-MM-YYYY hh:mm:ss A"
              );
              return <>{formattedDateTime}</>;
            } else {
              return <></>;
            }
          },
        },
        {
          // title: "Start Odometer",
          title: context.translate("_STOP_LOCATION_"),
          dataIndex: "stopLocation",
          key: "stopLocation",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Stop Odometer",
          title: context.translate("_FLEET_REPORTS_DISTANCEREPORT_STARTOD_"),
          dataIndex: "startDistance",
          key: "startDistance",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Stop Odometer",
          title: context.translate("_FLEET_REPORTS_DISTANCEREPORT_STOPOD_"),
          dataIndex: "stopDistance",
          key: "stopDistance",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Entered Odometer",
          title: context.translate("_DISTANCE_TRAVELED_"),
          dataIndex: "distanceTravel",
          key: "distanceTravel",
          ellipsis: {
            showTitle: true,
          },
        },

        {
          // title: "Amount",
          title: context.translate("_DRIVER_NAME_"),
          dataIndex: "driverName",
          key: "driverName",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Fuel",
          title: context.translate("_DRIVER_MOBILE_NO_"),
          dataIndex: "mobileno",
          key: "mobileno",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "Fuel Filled",
          title: context.translate("_MAX_SPEED_1"),
          dataIndex: "maxSpeed",
          key: "maxSpeed",
          ellipsis: {
            showTitle: true,
          },
        },

        {
          // title: "Total Run Km",
          title: context.translate("_TRAVEL_TIME_"),
          dataIndex: "travelduration",
          key: "travelduration",
          ellipsis: {
            showTitle: true,
          },
        },

        {
          // title: " Fuel Consumed ",
          title: context.translate("_IDLE_TIME_"),
          dataIndex: "idleduration",
          key: "idleduration",
          ellipsis: {
            showTitle: true,
          },
          // fixed:'right'
        },
        {
          // title: " Fuel Consumed ",
          title: context.translate("_EXIDLE_TIME_"),
          dataIndex: "exidleduration",
          key: "exidleduration",
          ellipsis: {
            showTitle: true,
          },
          // fixed:'right'
        },
        {
          // title: " Fuel Consumed ",
          title: context.translate("_TOTAL_STOP_"),
          dataIndex: "stopduration",
          key: "stopduration",
          ellipsis: {
            showTitle: true,
          },
          // fixed:'right'
        },
        {
          // title: " Fuel Consumed ",
          title: context.translate("_IDLE_COUNT_"),
          dataIndex: "idleCount",
          key: "idleCount",
          ellipsis: {
            showTitle: true,
          },
          // fixed:'right'
        },
        {
          // title: " Fuel Consumed ",
          title: context.translate("_OVER_SPEED_"),
          dataIndex: "overspeedCount",
          key: "overspeedCount",
          ellipsis: {
            showTitle: true,
          },
          // fixed:'right'
        },
        {
          // title: "Seatbelt Violation",
          title: context.translate("_SEATBELT_VIOLATION_"),
          dataIndex: "seatbeltViolation",
          key: "seatbeltViolation",

          // fixed: 'right',
        },
        {
          title: context.translate("_FLEET_RULESELECTORDETAIL_RULE1_TITLE_"),
          dataIndex: "harshBraking",
          key: "harshBraking",

          // fixed: 'right',
        },
        {
          title: context.translate("_FLEET_RULESELECTORDETAIL_RULE2_TITLE_"),
          dataIndex: "harshAcc",
          key: "harshAcc",

          // fixed: 'right',
        },
        {
          title: context.translate("_HARSH_TURNING_"),
          dataIndex: "harshTurning",
          key: "harshTurning",

          // fixed: 'right',
        },
        {
          // title: "Start Odometer",
          title: context.translate("_FUEL_CONSUMED_"),
          dataIndex: "fuelConsumed",
          width: "15%",
          key: "fuelConsumed",
        },
        {
          // title: "Start Odometer",
          title: context.translate("_CURRENT_FUEL_LEVEL_"),
          dataIndex: "currentFuelLevel",
          width: "15%",
          key: "currentFuelLevel",
        },
        {
          // title: "Start Odometer",
          title: context.translate("_SCORE_"),
          dataIndex: "score",
          width: "15%",
          key: "score",
        },
      ]),
    };
    this.ExportMenuProps = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={Excel}
              ></Image>
              {context.translate("_EXPORT_AS_EXCEL_")}
            </div>
          ),
          key: "excel",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={PDF}
              ></Image>
              {context.translate("_EXPORT_AS_PDF_")}
            </div>
          ),
          key: "pdf",
        },
      ],
      onClick: async (val) => {
        let result = [];
        console.log(val);
        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));
          var getData = {
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            colList: result.toString(),
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
          };

          if (val.key === "excel") {
            // console.log("afd")
            await this.fleetDaySummaryReport.exportExcel(getData);
            const isSuccess =
              this.fleetDaySummaryReport?.pythonReportMessage === true;
            const isError =
              this.fleetDaySummaryReport?.pythonReportErrorMessage;

            if (isSuccess || isError) {
              await this.setState({
                reportmessage: isSuccess ? "success" : "error",
              });
              await this.triggerReport();
            }
          }

          if (val.key === "pdf") {
            await this.fleetDaySummaryReport.exportpdf(getData);

            const isSuccess =
              this.fleetDaySummaryReport?.pythonReportMessage === true;
            const isError =
              this.fleetDaySummaryReport?.pythonReportErrorMessage;

            if (isSuccess || isError) {
              await this.setState({
                reportmessage: isSuccess ? "success" : "error",
              });
              await this.triggerReport();
            }
          }

          if (val.key == "csv") {
            this.fleetDaySummaryReport.exportcsv(getData);
          }
          // if (val.key == "xml") {
          //   this.fleetDaySummaryReport.exportxml(getData);
          // }
        }
      },
    };
    this.newColumns = [...this.state.selectedColumns];
  }
  async componentDidMount() {
    // await this.fuelFilledReportStore.loadData({ offset: 0, limit: 20 });

    this.setState({ pageSize: 50 });

    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }

    await this.setState({ column: this.state.selectedColumns });
  }

  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    console.log(this.state.selectedVehicles);

    await this.setState({ selectedVehicles: [], selectAllVehicles: false });

    await this.setState({ companyId: comp?.value });
    await this.vehicleStore.getVehiclesCompanyId(comp?.value);

    await this.handleSearch();
    //  console.log(data,"sdcd")
  }

  async handleSearch() {
    this.setState({ Notasset: false });
    // await this.fuelFilledReportStore.loadData({
    //   offset: (this.state.currentPage - 1) * this.state.pageSize,
    //   limit: this.state.pageSize,
    //   companyId: this.state.companyId,
    //   pageNo: this.state.currentPage,
    // });
    await this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    // this.handleSearch();
    await this.showData();
  }

  showData = async () => {
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }
    if (this.state.selectedVehicles.length === 0) {
      this.setState({ Notasset: true });
    } else {
      this.setState({ Notasset: false });
    }
    if (!this.state.fromDate) {
      this.setState({ fromDateNotSelected: true });
    } else {
      this.setState({ fromDateNotSelected: false });
    }
    if (!this.state.toDate) {
      this.setState({ toDateNotSelected: true });
    } else {
      this.setState({ toDateNotSelected: false });
    }

    if (
      this.state.companyId &&
      this.state.selectedVehicles.length > 0 &&
      this.state.fromDate &&
      this.state.toDate
    ) {
      // this.setState({mandatory:false})
      this.setState({ Notcompany: false, Notasset: false });
      if (this.checkFromDate(this.state.fromDate)) {
        await this.fleetDaySummaryReport.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: this.state.companyId,
          vehicleId: this.state.selectedVehicles,

          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
          pageNo: this.state.currentPage,
        });
        await this.setState({ listData: 1 });
      }
    }
  };

  handleCheckboxChange = async (column) => {
    console.log(column);
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      console.log(filtered);
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      console.log("adsf");
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };
  addMonths = (date, months) => {
    // date.setMonth(date.getMonth() + months);
    // date = date + months;
    var indx = dayjs().month() + -6;
    // return date.format("YYYY-MM-DD HH:mm:ss");
    return dayjs().month(indx);
  };

  checkFromDate(dates) {
    // console.log(dates);
    var fromDate = dates;
    var pdate = this.addMonths();
    if (pdate > fromDate) {
      this.setState({ showMonthPopup: true });
      return false;
    } else {
      return true;
    }
  }

  handleAllSelectVehicles = async (e) => {
    if (this.state.selectAllVehicles) {
      const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId.map(
        (val) => {
          return val.vehicleId;
        }
      );
      await this.setState({ selectedVehicles: allVehicles });
    } else {
      await this.setState({ selectedVehicles: [] });
    }
  };
  refreshList = async () => {
    await this.setState({ loading: false, current: 1, currentPage: 1 });
    await this.showData();
  };
  triggerReport = () => {
    this.pythonMessageRef.current.show(); // show the modal
  };
  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  allowClear={true}
                  className="searchInput"
                  onChange={this.handleChange}
                  style={{ width: 150 }}
                  // style={companyInputStyle}
                  status={this.state.Notcompany ? "error" : false}
                />
                {this.props.getUserData().isadmin === 1 && (
                  <DeviceGroupsForVehicles
                    vehicleStore={this.vehicleStore}
                    setLoadDta={() => this.setState({ loadData: 1 })}
                    resetVehicles={() =>
                      this.setState({
                        selectedVehicles: [],
                        selectAllVehicles: false,
                      })
                    }
                  />
                )}
                <Checkbox
                  checked={this.state.selectAllVehicles}
                  onChange={async (e) => {
                    await this.setState({
                      selectAllVehicles: e.target.checked,
                    });
                    // console.log(e.target.checked);
                    await this.handleAllSelectVehicles();
                  }}
                />

                {this.context.translate("_ALL_")}

                <Select
                  maxTagCount="responsive"
                  className="searchInput"
                  value={this.state.selectedVehicles}
                  onChange={(val) => {
                    this.setState({ selectedVehicles: val });
                    if (
                      this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                      val.length
                    ) {
                      this.setState({ selectAllVehicles: false });
                    } else {
                      this.setState({ selectAllVehicles: true });
                    }

                    if (val?.length > 1) {
                      console.log(val?.length > 1);
                      this.setState({ showAlertPopup: true });
                    }
                  }}
                  style={{ width: 200 }}
                  showSearch
                  status={this.state.Notasset ? "error" : false}
                  mode="multiple"
                  placeholder={this.context.translate(
                    "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                  )}
                  filterOption={(inputValue, option) => {
                    if (option.children) {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) >= 0
                      );
                    }
                  }}
                >
                  {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                    return (
                      <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                    );
                  })}
                </Select>
                <DatePicker
                  status={this.state.fromDateNotSelected ? "error" : false}
                  defaultValue={dayjs()}
                  style={{ width: 150, borderRadius: "25px" }}
                  placeholder="From Date"
                  disabledDate={(current) => {
                    return current && current > dayjs();
                  }}
                  onChange={(date) => {
                    console.log(date);
                    if (date === null) {
                      this.setState({ fromDate: "" });
                    } else {
                      this.setState({ fromDate: date.format("YYYY-MM-DD") });
                    }
                  }}
                />

                <DatePicker
                  status={this.state.toDateNotSelected ? "error" : false}
                  defaultValue={dayjs()}
                  style={{ width: 150, borderRadius: "25px" }}
                  placeholder="To Date"
                  onChange={(date) => {
                    console.log(date);
                    if (date === null) {
                      this.setState({ toDate: "" });
                    } else {
                      this.setState({ toDate: date.format("YYYY-MM-DD") });
                    }
                  }}
                  disabledDate={(current) => {
                    return current && current > dayjs();
                  }}
                />
                <Button
                  type="primary"
                  onClick={async () => {
                    await this.setState({ currentPage: 1, pageSize: 50 });
                    await this.showData();
                  }}
                >
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>
                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={4}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.fleetDaySummaryReport?.fleetDaySummaryReport?.length >
                    0
                      ? false
                      : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.ExportMenuProps}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>
              </Space>
            </Col>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.fleetDaySummaryReport?.total}
            columns={this.state.column}
            dataSource={this.fleetDaySummaryReport?.fleetDaySummaryReport}
            loading={this.fleetDaySummaryReport?.loading}
            onChange={this.handleTableChange}
            {...(conf.currentFlavor === "nodeui" && {
              showSizeChanger: false,
              moreClass: "gridNum",
            })}
          />
        </div>
        <Modal
          open={this.state.modalVisible}
          width={300}
          // title="Select Columns"
          title={this.context.translate("_SELECT_COLUMNS_")}
          onCancel={() => this.setState({ modalVisible: false })}
          onOk={() => {
            this.setState({ modalVisible: false });
          }}
          footer={null}
        >
          <div style={{ maxHeight: "400px", overflowY: "auto" }}>
            {console.log(this.newColumns, "Df")}
            {this.newColumns.map((column, v) => {
              return (
                <Row key={v}>
                  <Col>
                    <Checkbox
                      onChange={() => this.handleCheckboxChange(column)}
                      checked={this.state.selectedColumns.some(
                        (c) => c.key === column.key
                      )}
                    >
                      {column.title}
                    </Checkbox>
                  </Col>
                </Row>
              );
            })}
          </div>
        </Modal>

        <Modal
          width={350}
          className="alert-model"
          title={
            <div>
              {" "}
              <i
                style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                class="bi bi-exclamation-triangle"
              ></i>{" "}
              {/* Alert */}
              {this.context.translate("_FLEET_ALERT_")}
            </div>
          }
          open={this.state.showMonthPopup}
          onOk={() => this.setState({ showMonthPopup: false })}
          onCancel={() => this.setState({ showMonthPopup: false })}
          footer={false}
        >
          {/* For reports prior to 6 months please contact administrator */}
          {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
        </Modal>

        {
          <div>
            <PythonMessageAlert
              ref={this.pythonMessageRef}
              message={this.state.reportmessage}
            />
          </div>
        }
      </>
    );
  }
}
FleetDaySummaryReport.contextType = StoreContext;
export default observer(withRouter(FleetDaySummaryReport));
